import HtmlRenderingDiffView from './HtmlRenderingDiffView';
import StreamingHtmlRenderingDiffView from './StreamingHtmlRenderingDiffView';

interface Props {
  originalText: string;
  newText: string;
  mode?: 'words' | 'chars';
  isLoading?: boolean;
}

function DiffView({
  originalText,
  newText,
  mode = 'words',
  isLoading = false,
}: Props) {
  if (isLoading) {
    return (
      <StreamingHtmlRenderingDiffView
        originalText={originalText}
        streamingText={newText}
        mode={mode}
        isStreaming={true}
      />
    );
  }

  return (
    <HtmlRenderingDiffView
      originalText={originalText}
      newText={newText}
      mode={mode}
    />
  );
}

export default DiffView;
